import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, List, ListItem, ListItemText, Typography, IconButton, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { format } from 'date-fns';

const QueryHistoryDialog = (props) => {
  const { open, onClose, previousQueries, onSelectQuery } = props;
  const [userQuery, setUserQuery] = useState([]);

  const handleQuerySelect = (query) => {
    console.log('Selected Query', query);
    onSelectQuery(query);
    onClose();
  };

  useEffect(() => {
    if (previousQueries && previousQueries.length > 0) {
      setUserQuery(previousQueries);
    }
  }, [previousQueries]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Last 20 Saved Queries
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ maxHeight: "60vh", overflow: "auto" }}>
        {userQuery && userQuery.length === 0 ? (
          <Typography variant="body1" color="text.secondary">
            No previous queries found
          </Typography>
        ) : (
          <List>
            {userQuery.map((query, index) => (
              <React.Fragment key={index}>
                <ListItem
                  button
                  onClick={() => handleQuerySelect(query)}
                  sx={{
                    mb: 1,
                    mt: 1,
                    "&:hover": {
                      backgroundColor: "rgba(112, 177, 246, 0.04)",
                    },
                  }}
                >
                  <ListItemText
                    primary={query.query_name}
                    secondary={query.user_query}
                    primaryTypographyProps={{
                      noWrap: true,
                      display: "block",
                      fontSize: "18px",
                    }}
                    secondaryTypographyProps={{
                      noWrap: true,
                      display: "block",
                      color: "text.secondary",
                    }}
                  />
                </ListItem>
                {index !== userQuery.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default QueryHistoryDialog; 